import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=e391eb86&"
import script from "./categories.vue?vue&type=script&lang=ts&"
export * from "./categories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports